import { Navigate } from "react-router-dom";
import { useAuthContext } from "./AuthProvider";
import Loader from "components/Loader";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { isAuthenticated, isLoading } = useAuthContext();

  if (isLoading) {
    return (
      <Loader
        txt="Loading..."
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      />
    );
  }

  return isAuthenticated ? children : <Navigate to="/auth/sign-in" replace />;
};

export default ProtectedRoute;
